import { useQuery } from "@tanstack/react-query";
import ApiClient from "../../../api/ApiClient";
import { UserAssignment } from "../interfaces/UserAssignment";

async function list(): Promise<UserAssignment[]> {
    const response = await ApiClient({ url: "/user-assignments", method: "GET" });

    if (response.status === 200) {
        return response.data;
    }
    throw new Error(response.data);
}

export function useListUserAssignmentsQuery() {
    return useQuery<UserAssignment[]>({
        queryKey: ["get-user-assignments"],
        queryFn: list,
        refetchOnWindowFocus: false
    });
}